import { render, staticRenderFns } from "./CatalogsTree.vue?vue&type=template&id=3ffc6706&"
import script from "./CatalogsTree.vue?vue&type=script&lang=js&"
export * from "./CatalogsTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports